'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var seekDomainCheck = /seek\.(com\.au|co\.nz)/;

var dashboardLinks = ['dashboard-save-search-click', 'dashboard-all-saved-searches-click', 'dashboard-heading-saved-searches-click', 'dashboard-save-job-click', 'dashboard-all-saved-jobs-click', 'dashboard-heading-saved-jobs-click', 'dashboard-recommended-job-click', 'dashboard-all-recommended-jobs-click', 'dashboard-heading-recommended-jobs-click'];

var signInLink = 'sign-in';
var registerLink = 'register';

exports.default = function (href, linkName) {
  if (dashboardLinks.indexOf(linkName) >= 0) {
    return 'dashboard-link';
  }

  if (signInLink === linkName) {
    return 'sign-in-link';
  }

  if (registerLink === linkName) {
    return 'register-link';
  }

  return seekDomainCheck.test(href) ? 'link' : 'exit-link';
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/utils/evaluateLinkType.js
 ** module id = 426
 ** module chunks = 0
 **/